import { render, staticRenderFns } from "./listmb.vue?vue&type=template&id=139b14b9&scoped=true"
import script from "./listmb.vue?vue&type=script&lang=js"
export * from "./listmb.vue?vue&type=script&lang=js"
import style0 from "./listmb.vue?vue&type=style&index=0&id=139b14b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139b14b9",
  null
  
)

export default component.exports